<template>
  <sticky-header-layout>
    <template #header>
      <list-page-header>
        <div slot="right">
          <el-button
            :disabled="isSaving"
            class="cancel-button"
            size="mini"
            type="warning"
            icon="el-icon-close"
            @click="handleCancel"
          >
            {{ $t('button.cancel') }}
          </el-button>
          <el-button
            :disabled="isLoading"
            :loading="isSaving"
            class="save-button"
            size="mini"
            type="danger"
            icon="el-icon-upload2"
            @click="handleSave"
          >
            {{ $t('button.save') }}
          </el-button>
        </div>
      </list-page-header>
    </template>

    <el-form
      v-loading="isLoading"
      ref="form"
      :disabled="isSaving"
      :model="couponForm"
      :rules="storeFormRule"
      class="round-border-form"
      label-position="top"
      label-width="200"
    >
      <h4 class="title">Add Discount Coupon</h4>
      <div class="form-group">
        <el-form-item
          label="Title"
          prop="title"
        >
          <el-input
            v-model="couponForm.title"
            clearable
          />
        </el-form-item>
        <el-form-item
          label="Title ZH HK"
          prop="title_zh_hk">
          <el-input
            v-model="couponForm.title_zh_hk"
            clearable
          />
        </el-form-item>
      </div>

      <div class="form-group">
        <el-form-item
          label="Title ZH CN"
          prop="title_zh_cn"
        >
          <el-input
            v-model="couponForm.title_zh_cn"
            clearable
          />
        </el-form-item>
        <el-form-item
          label="Title TH"
          prop="title_th_th"
        >
          <el-input
            v-model.trim="couponForm.title_th_th"
            clearable
          />
        </el-form-item>
      </div>

      <!-- <div class="form-group">
        <el-form-item
          label="Code"
          prop="codes"
        >
          <el-input
            v-model.trim="couponForm.codes"
            clearable
          />
        </el-form-item>
        <el-form-item
          label="Amount"
          prop="amount"
        >
          <el-input
            v-model.number="couponForm.amount"
            type="string"
            placeholder="15%/HKD200"
          >
          </el-input>
        </el-form-item>
      </div> -->

      <div class="form-group">
        <el-form-item
          label="Date Range"
          prop="dateRange"
        >
          <el-date-picker
            v-model="couponForm.dateRange"
            type="daterange"
            start-placeholder="Start date"
            end-placeholder="End date">
          </el-date-picker>
        </el-form-item>
      </div>

      <div class="form-group">
        <el-form-item
          label="Merchant"
          prop="merchant"
        >
          <el-select
            v-model="couponForm.merchant"
            label="Merchant"
          >
            <el-option
              v-for="merchant in merchants"
              :key="merchant.id"
              :label="merchant.name"
              :value="merchant.id"
            />
          </el-select>
        </el-form-item>
      </div>

      <div class="form-group">
        <el-form-item
          label="Quota"
          prop="quota"
        >
          <el-input
            v-model.number="couponForm.quota"
            type="number"
            placeholder="please input -1 if the quota is unlimited"
          >
          </el-input>
        </el-form-item>
        <el-form-item
          label="Quota per user"
          prop="per_user_quota"
        >
          <el-input
            v-model.number="couponForm.per_user_quota"
            type="number"
            placeholder="please input -1 if the quota is unlimited"
          >
          </el-input>
        </el-form-item>
      </div>

      <div class="form-group">
        <el-form-item
          label="First Purchase Only"
          prop="is_first_purchase_only"
        >
          <el-switch
            v-model="couponForm.is_first_purchase_only"
            inactive-color="#f56c6c"
          />
        </el-form-item>
      </div>
      <div class="form-group">
        <el-form-item
          label="Device First Purchase Only"
          prop="is_device_first_purchase_only"
        >
          <el-switch
            v-model="couponForm.is_device_first_purchase_only"
            inactive-color="#f56c6c"
          />
        </el-form-item>
      </div>
      <div class="form-group">
        <el-form-item
          label="App Only"
          prop="is_app_only"
        >
          <el-switch
            v-model="couponForm.is_app_only"
            inactive-color="#f56c6c"
          />
        </el-form-item>
      </div>

      <div class="form-group">
        <el-form-item
          label="Status"
          prop="status"
        >
          <el-radio
            v-model="couponForm.status"
            label="1"
          >
            Enabled
          </el-radio>
          <el-radio
            v-model="couponForm.status"
            label="0"
          >
            Disabled
          </el-radio>
        </el-form-item>
      </div>
      <div class="form-group">
        <el-form-item
          label="Paid By"
          prop="paid_by"
        >
          <el-radio
            v-model="couponForm.paid_by"
            label="1"
          >
            Goxip
          </el-radio>
          <el-radio
            v-model="couponForm.paid_by"
            label="0"
          >
            Merchant
          </el-radio>
        </el-form-item>
      </div>

      <div class="form-group">
        <el-form-item
          label="Amount"
          prop="amount"
        >
          <el-input
            v-model.number="couponForm.amount"
            type="number"
          >
          </el-input>
        </el-form-item>
        <el-form-item
          label="Discount Type"
          prop="discount_type"
        >
          <el-select
            v-model="couponForm.discount_type"
            label="Discount Type"
          >
            <el-option
              v-for="type in discountType"
              :key="type.id"
              :label="type.name"
              :value="type.id"
            />
          </el-select>
        </el-form-item>
      </div>

      <div class="form-group">
        <el-form-item
          label="Currency"
          prop="currency"
        >
          <el-select
            v-model="couponForm.currency"
            label="currency"
          >
            <el-option
              v-for="currency in currencyList"
              :key="currency.code"
              :label="currency.code"
              :value="currency.code"
            />
          </el-select>
        </el-form-item>
      </div>
      <div class="form-group">
        <el-form-item
          label="Apply to"
          prop="apply_to"
        >
          <el-select
            v-model="couponForm.apply_to"
            label="apply to"
          >
            <el-option
              v-for="el in applyTo"
              :key="el.id"
              :label="el.name"
              :value="el.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          label="Apply before product discount"
          prop="apply_before_product_discount"
        >
          <el-switch
            v-model="couponForm.apply_before_product_discount"
            inactive-color="#f56c6c"
          />
        </el-form-item>
      </div>
      <div class="form-group">
        <el-form-item
          label="Min Purchase Amount"
          prop="minimum_purchase_amount"
        >
          <el-input
            v-model.number="couponForm.minimum_purchase_amount"
            type="number"
          >
          </el-input>
        </el-form-item>
        <el-form-item
          label="Min Purchase Quatity"
          prop="minimum_purchase_quantity"
        >
          <el-input
            v-model.number="couponForm.minimum_purchase_quantity"
            type="number"
          >
          </el-input>
        </el-form-item>
      </div>
      <div class="form-group">
        <el-form-item
          label="One Time Promotion"
          prop="one_time_promotion"
        >
          <el-switch
            v-model="couponForm.one_time_promotion"
            inactive-color="#f56c6c"
          />
        </el-form-item>
        <el-form-item
          label="Exclude Shipping Fee"
          prop="exclude_shipping_fee"
        >
          <el-switch
            v-model="couponForm.exclude_shipping_fee"
            inactive-color="#f56c6c"
          />
        </el-form-item>
      </div>

      <div class="form-group">
        <el-form-item
          label="Apply To Merchant Country"
          prop="apply_to_merchant_country_id"
        >
          <el-select
            v-model="couponForm.apply_to_merchant_country_id"
            label="apply to merchant country"
          >
            <el-option
              v-for="country in countryList"
              :key="country.id"
              :label="country.name"
              :value="country.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          label="Prioriy"
          prop="priority"
        >
          <el-select
            v-model="couponForm.priority"
            label="Priority"
          >
            <el-option
              v-for="priority in priorities"
              :key="priority.id"
              :label="priority.id"
              :value="priority.id"
            />
          </el-select>
        </el-form-item>
      </div>
      <div class="form-group">
        <el-form-item
          label="Additional Info"
          prop="additional_info"
        >
          <el-input
            v-model.number="couponForm.additional_info"
            type="textarea"
          >
          </el-input>
        </el-form-item>
      </div>
    </el-form>
  </sticky-header-layout>
</template>

<script>
import FieldsetLocalizedInput from '@/components/form/FieldsetLocalizedInput.vue'
import MarketplaceService from '../../api/marketplace'
import { formatDatetime } from '../../utils/datetime'

export default {
  name: 'AddCoupon',
  components: {
    FieldsetLocalizedInput,
  },
  props: {
    id: {
      type: [String, Number],
      default: '',
    },
  },
  data() {
    return {
      couponForm: {
        status: false,
        dateRange: '',
        title: '',
        title_zh_hk: '',
        title_zh_cn: '',
        title_th_th: '',
        codes: '',
        merchant_id: '',
        quota: '',
        per_user_quota: '',
        is_first_purchase_only: false,
        is_device_first_purchase_only: false,
        is_app_only: false,
        apply_to_merchant_id: '',
        discount_type: '',
        currency: '',
        amount: '',
        apply_to: '',
        apply_before_product_discount: false,
        minimum_purchase_amount: '',
        minimum_purchase_quantity: '',
        one_time_promotion: false,
        exclude_shipping_fee: false,
        apply_to_merchant_country_id: '',
        priority: '',
        additional_info: '',
      },
      // storeFormRule: {
      //   name: [{ required: true, message: this.$t('error.thisFieldIsRequired'), trigger: 'blur' }],
      //   displayname: [{ required: true, message: this.$t('error.thisFieldIsRequired'), trigger: 'blur' }],
      //   slug: [{ required: true, message: this.$t('error.thisFieldIsRequired'), trigger: 'blur' }],
      //   available_platform: [{
      //     type: 'array',
      //     required: true,
      //     message: 'Please select at least one platform ',
      //     trigger: 'change',
      //   }],
      //   username: [
      //     { required: true, message: this.$t('error.thisFieldIsRequired'), trigger: 'blur' },
      //     {
      //       validator: (rule, value, callback) => {
      //         if (/^[a-z0-9_]{4,}$/.exec(value)) {
      //           callback()
      //         }
      //         return callback(this.$t('error.invalidUsername'))
      //       },
      //       trigger: 'blur',
      //     },
      //   ],
      //   member_name: [{ required: true, message: this.$t('error.thisFieldIsRequired'), trigger: 'blur' }],
      //   // member_profile_image: [{ required: true, message: this.$t('error.thisFieldIsRequired'), trigger: 'blur' }],
      //   rs_min_commission_percentage: [{ validator: validateIsNonNegativeNumber, trigger: 'blur' }],
      //   rs_max_commission_percentage: [{ validator: validateIsNonNegativeNumber, trigger: 'blur' }],
      //   tier: [{ required: true, message: this.$t('error.thisFieldIsRequired'), trigger: 'blur' }],
      // },
      merchants: [],
      discountType: [
        {id: 1, name: 'Percentage'},
        {id: 2, name: 'Cash Discount'},
        {id: 3, name: 'Free Shipping'},
      ],
      currencyList: [],
      applyTo: [
        {id: 1, name: 'Product'},
        {id: 2, name: 'Order'},
      ],
      countryList: [],
      priorities: [
        {id: 1},
        {id: 2},
        {id: 3},
      ],
    }
  },
  watch: {
    handleSaveSuccess() {
      this.isSaving = false
      this.isEdited = false
      // this.goToTrendingFeeds()
    },
    handleSaveFail(error) {
      this.isSaving = false
      this.$alert(`Error: ${error}`, this.$t('error.somethingWentWrong'), {
        type: 'error',
        confirmButtonText: this.$t('button.ok'),
      })
    },
  },
  mounted() {
    this.fetchMerchants()
    this.getCurrencyList()
    this.getCountryList()
  },
  // async beforeRouteLeave(to, from, next) {
  //   if (this.isSaving) {
  //     return next(false)
  //   }

  //   if (!this.isEdited) {
  //     return next()
  //   }

  //   try {
  //     await this.$confirm(this.$t('message.leaveWithUnsavedChanges'), this.$t('common.warning'), {
  //       confirmButtonText: this.$t('button.leave'),
  //       cancelButtonText: this.$t('button.cancel'),
  //       type: 'warning',
  //     })
  //     return next()
  //   } catch (error) {
  //     return next(false)
  //   }
  // },
  methods: {
    handleSaveSuccess() {
      this.isSaving = false
      this.isEdited = false
      this.goToCouponList()
    },
    handleSaveFail(error) {
      this.isSaving = false
      this.$alert(`Error: ${error}`, this.$t('error.somethingWentWrong'), {
        type: 'error',
        confirmButtonText: 'OK',
      })
    },
    goToCouponList() {
      this.$router.push({ path: '/marketplace/couponlist' })
    },
    handleCancel() {
      this.goToCouponList()
    },
    async handleSave() {
      this.isSaving = true
      console.log(this.couponForm.dateRange[0])

      var s = this.couponForm.dateRange[0]
      var startDate = s.getFullYear() + '-' + (s.getMonth()+1) + '-' + s.getDate() + " " + ('0' + s.getHours()).slice(-2) + ":" + ('0' + s.getMinutes()).slice(-2) + ":" + ('0' + s.getSeconds()).slice(-2)

      var e = this.couponForm.dateRange[1]
      var endDate = e.getFullYear() + '-' + (e.getMonth()+1) + '-' + e.getDate() + " " + ('0' + e.getHours()).slice(-2) + ":" + ('0' + e.getMinutes()).slice(-2) + ":" + ('0' + e.getSeconds()).slice(-2)

      this.couponForm.start_at = startDate
      this.couponForm.end_at = endDate
      this.couponForm.codes = [this.couponForm.codes]
      this.couponForm.apply_to_merchant_id = this.couponForm.merchant_id
      const id = this.$route.params.id
      try {
        await MarketplaceService.addCoupon({form: this.couponForm, id})
        this.handleSaveSuccess()
      } catch(e) {
        this.handleSaveFail(e)
      }
    },
    async fetchMerchants() {
      // this.isFetchingMerchants = true
      try {
        const response = await MarketplaceService.getMerchantList()
        this.merchants = [
          ...response.data,
        ]
      } finally {
        // this.isFetchingMerchants = false
      }
    },
    async getCurrencyList() {
      const res = await MarketplaceService.getCurrencyList()
      this.currencyList = [...res.data]
    },
    async getCountryList() {
      const res = await MarketplaceService.getCountryList()
      this.countryList = [...res.data]
    }
  },
}
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/view-base.scss";
@import "~@/assets/styles/table.scss";
@import "~@/assets/styles/form.scss";
</style>

<style lang="scss">
.el-form--label-top .el-form-item__label {
  padding: 0;
}

</style>
